import { useState } from "react";
import { ChevronDown, Download, FileDown } from "lucide-react";
import useMediaKitDownload from "../hooks/useMediaKitDownload";
import { MEDIA_KIT_ASSETS } from "../data/mediaKitAssets";

export default function MediaKitPanel() {
  const { status, download } = useMediaKitDownload();
  const [browsing, setBrowsing] = useState(false);

  return (
    <div>
      <div className="flex flex-wrap gap-3">
        <button
          type="button"
          onClick={download}
          disabled={status === "generating"}
          className="inline-flex items-center gap-2 rounded-full bg-ocean-900 px-5 py-2.5 text-sm font-semibold text-foam-50 transition-transform hover:scale-105 disabled:opacity-60 disabled:hover:scale-100 dark:bg-teal-400 dark:text-ocean-950"
        >
          <Download className="h-4 w-4" />
          {status === "generating" ? "Preparing ZIP…" : "Download Media Kit"}
        </button>
        <button
          type="button"
          onClick={() => setBrowsing((v) => !v)}
          aria-expanded={browsing}
          className="inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-semibold text-ocean-900 ring-1 ring-ocean-900/15 transition-colors hover:bg-ocean-900/5 dark:text-foam-50 dark:ring-white/15 dark:hover:bg-white/10"
        >
          Browse Assets
          <ChevronDown className={`h-4 w-4 transition-transform ${browsing ? "rotate-180" : ""}`} />
        </button>
      </div>
      {status === "error" && (
        <p className="mt-2 text-xs text-coral-500">Couldn&apos;t generate the media kit — please try again.</p>
      )}

      {browsing && (
        <ul className="mt-4 space-y-2">
          {MEDIA_KIT_ASSETS.map((asset) => (
            <li
              key={asset.id}
              className="flex items-center justify-between gap-3 rounded-xl bg-foam-50 p-3 text-sm dark:bg-white/5"
            >
              <div className="min-w-0">
                <p className="truncate font-medium text-ocean-950 dark:text-foam-50">{asset.label}</p>
                <p className="truncate text-xs text-ocean-800/60 dark:text-foam-100/60">{asset.description}</p>
              </div>
              <a
                href={asset.url}
                download={asset.filename}
                className="inline-flex shrink-0 items-center gap-1.5 rounded-full bg-white px-3 py-1.5 text-xs font-semibold text-ocean-900 ring-1 ring-ocean-900/10 hover:bg-ocean-900/5 dark:bg-ocean-900 dark:text-foam-50 dark:ring-white/10 dark:hover:bg-white/10"
              >
                <FileDown className="h-3.5 w-3.5" />
                Download
              </a>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
